// TableToolbar.js
// Shared toolbar used by AllLeads, ClientsList, AllBids, AllStock,
// AllSaleOrder, AllInvoice. Drop-in replacement for the existing JSX.

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint, faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';

export default function TableToolbar({
    searchTerm,
    onSearchChange,

    // Selection
    isSelectMode,
    onToggleSelectMode,
    onSelectAll,
    selectedCount,
    allSelected,

    // Actions
    onPrint,
    onExcel,
    onPDF,

    // Optional
    pageSize,
    onPageSizeChange,
    disabled = false,
}) {
    const hasSelection = selectedCount > 0;
    const actionDisabled = disabled || !hasSelection;

    return (
        <div className="toolbar">
            <div className="toolbar-left">
                <select
                    className="toolbar-select"
                    value={pageSize ?? 15}
                    onChange={(e) => onPageSizeChange && onPageSizeChange(Number(e.target.value))}
                >
                    <option value={15}>15</option>
                    <option value={30}>30</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>

                <button
                    className={`toolbar-btn ${isSelectMode ? 'grey' : 'green'}`}
                    onClick={onToggleSelectMode}
                    type="button"
                >
                    {isSelectMode ? 'Cancel' : 'Select'}
                </button>

                <button
                    className="toolbar-btn blue"
                    onClick={onSelectAll}
                    type="button"
                    disabled={!isSelectMode}
                    style={!isSelectMode ? { opacity: .55, cursor: 'not-allowed' } : undefined}
                >
                    {allSelected ? 'Unselect All' : 'Select All'}
                    {isSelectMode && selectedCount > 0 && (
                        <span style={{
                            marginLeft: 6,
                            background: 'rgba(255,255,255,.28)',
                            borderRadius: 8,
                            padding: '1px 6px',
                            fontSize: 10,
                            fontWeight: 800,
                        }}>
                            {selectedCount}
                        </span>
                    )}
                </button>

                <button
                    className="toolbar-btn red"
                    onClick={onPrint}
                    type="button"
                    disabled={actionDisabled}
                    title={actionDisabled ? 'Select at least one row' : 'Print selected'}
                    style={actionDisabled ? { opacity: .55, cursor: 'not-allowed' } : undefined}
                >
                    <FontAwesomeIcon icon={faPrint} style={{ width: '10px' }} />
                </button>

                <button
                    className="toolbar-btn blue"
                    onClick={onExcel}
                    type="button"
                    disabled={actionDisabled}
                    title={actionDisabled ? 'Select at least one row' : 'Download selected as Excel'}
                    style={actionDisabled ? { opacity: .55, cursor: 'not-allowed' } : undefined}
                >
                    <FontAwesomeIcon icon={faFileExcel} style={{ width: '10px' }} />
                </button>

                <button
                    className="toolbar-btn grey"
                    onClick={onPDF}
                    type="button"
                    disabled={actionDisabled}
                    title={actionDisabled ? 'Select at least one row' : 'Download selected as PDF'}
                    style={actionDisabled ? { opacity: .55, cursor: 'not-allowed' } : undefined}
                >
                    <FontAwesomeIcon icon={faFilePdf} style={{ width: '10px' }} />
                </button>
            </div>

            <div className="toolbar-search">
                <input
                    type="text"
                    placeholder="Search all columns:"
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
            </div>
        </div>
    );
}